import { noop } from 'ramda-adjunct';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../components/common';
import { AsyncNotificationStatus } from '../../../utils/hooks/useNotificator/useNotificator.types';
import { MediaManagerSDKAnyItem } from '../../../utils/media-manager-sdk';
import { DataHook, Truncated } from './components';
import styles from './components/Truncated/Truncated.scss';
import { GenericNotification } from './GenericNotification';

export const itemsRestoreNotification =
  ({
    items,
    targetName = null,
    onTargetClick = noop,
  }: {
    items: MediaManagerSDKAnyItem[];
    targetName?: string;
    onTargetClick?(): void;
  }) =>
  ({ notification }) =>
    (
      <DataHook dataHook="notification.restore" notification={notification}>
        <GenericNotification
          notification={notification}
          text={
            targetName ? (
              <FormattedMessage
                id={
                  notification.status === AsyncNotificationStatus.Pending
                    ? 'files-manager.restore-notification.with-target.pending'
                    : 'files-manager.restore-notification.with-target.done'
                }
                values={{
                  itemsCount: items.length,
                  itemName: <Truncated>{items[0].name}</Truncated>,
                  targetName: (
                    <TextButton
                      className={styles.truncated}
                      as="a"
                      size="small"
                      underline="always"
                      onClick={onTargetClick}
                      skin="dark"
                      dataHook="notification-link"
                    >
                      {targetName}
                    </TextButton>
                  ),
                }}
              />
            ) : (
              <FormattedMessage
                id={
                  notification.status === AsyncNotificationStatus.Pending
                    ? 'files-manager.restore-notification.pending'
                    : 'files-manager.restore-notification.done'
                }
                values={{
                  itemsCount: items.length,
                  itemName: <Truncated>{items[0].name}</Truncated>,
                }}
              />
            )
          }
        />
      </DataHook>
    );
